// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1sdQO","form":"styles_form__1woFY"};